(() => {
  let initSwiper = (section) => {
    if (section && section.classList.contains('section-announcement')) {
      const swiperEl = section.querySelector('.announcement-bar--swiper');
      if (swiperEl) {
        const config = {
          speed: Number(swiperEl.dataset.speed),
          direction: 'vertical',
          spaceBetween: 8,
          autoHeight: true,
          loop: true,
          autoplay: {
            delay: Number(swiperEl.dataset.delay),
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          },
        };
        new Swiper(swiperEl, config);
      }
    }
  };

  let observeAnnouncement = (section) => {
    if (section && section.classList.contains('section-announcement')) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            document.documentElement.style.setProperty('--ann-bar-height', entry.boundingClientRect.height + 'px');
          } else {
            document.documentElement.style.setProperty('--ann-bar-height', '0px');
          }
        });
      }).observe(section);
    }
  };

  initSwiper(document.currentScript.parentElement);
  observeAnnouncement(document.currentScript.parentElement);
  document.addEventListener('shopify:section:load', (e) => {
    initSwiper(e.target);
    observeAnnouncement(e.target);
  });
})();
